import React from 'react'
import { ArrowRight } from 'react-bootstrap-icons'
import { isNonEmptyString } from '@/utils/checks'
export const NavBrowseButton: React.FC<{ label?: string; href?: string }> = ({
  label,
  href
}) => {
  if (!isNonEmptyString(label) || !isNonEmptyString(href)) return null

  return (
    <a
      className={`[text-decoration-none] mt-[-24px] flex h-12 flex-row items-center gap-x-2`}
      href={href}
    >
      <span className={`text-lg font-medium text-gray-1100`}>{label} </span>

      <ArrowRight className="size-4 text-gray-1100" />
    </a>
  )
}
